import { Paper } from "@mui/material";
import BrandConfigurationReportHead from "./BrandConfigurationReportHead";
import BrandConfigurationReportTable from "./BrandConfigurationReportTable/BrandConfigurationReportTable";

const BrandConfigurationReport = () => {
  return (
    <>
      <Paper>
        <BrandConfigurationReportHead />
        <BrandConfigurationReportTable />
      </Paper>
    </>
  );
};

export default BrandConfigurationReport;
